import { ReadOnlyUser, RegularUser, ReportViewer, SiteAdmin } from './AuthorizationRoles';

import JobMatchingContainer from '../JobMatching/JobMatchingContainer';
import RulesContainer from '../Rules/RulesContainer';
import ReportLibraryContainer from '../../containers/ReportLibrary/ReportLibrary';
import ReportContainer from '../../containers/Report/ReportContainer';
import Ranges from 'ps-components/Modules/JobRanges/JobRanges';
import MarketPricingContainer from '../MarketPricing/MarketPricingContainer';
import CompetitiveSetsContainer from 'ps-components/Modules/CompetitiveSets/CompetitiveSets';
import PayScalePulse from 'ps-components/Modules/PayScalePulse/PulseLandingPage';
import StructureModeling from '../StructureModeling/StructureModeling';
import SurveyLibraryUpdateContainer from '../SurveyLibraryUpdate/SurveyLibraryUpdateContainer';
import DataCutMigration from '../DataCutMigration/DataCutMigration';
import DataCutMigrationDetails from '../DataCutMigration/Details/DataCutMigrationDetails';
import GeoDifferential from 'ps-components/Modules/PayScalePulse/GeoDifferential/GeoLandingPage';
import ViewListContainer from '../MarketPricing/ConfigureView/ViewList';
import EditPricingVersionDetails from '../GlobalJobMatching/GlobalJobMatchingVersioning/EditPricingVersionDetails/EditPricingVersionDetails';
import GloJamPricingVersionStepperContainer from '../../containers/GlobalJobMatching/PricingVersionStepper'
import GlobalJobMatchingVersioningLanding from '../GlobalJobMatching/GlobalJobMatchingVersioning/Landing';
import GloJamVersionsListContainer from '../../containers/GlobalJobMatching/PricingVersionsList'
import ReportLibraryContainerNew from '../../containers/ReportLibraryNew';
import BulkPricingContainer from '../MarketPricing/BulkPricing/BulkPricing';
import PropagateMatchesContainer from '../MarketPricing/PropagateMatches/PropagateMatches';

export const JobMatching = RegularUser(JobMatchingContainer);
export const RulesBasedPricing = RegularUser(RulesContainer);
export const ReportLibraryNew = ReportViewer(ReportLibraryContainerNew);
export const Report = ReportViewer(ReportContainer);
export const ReportLibrary = ReportViewer(ReportLibraryContainer);
export const JobBasedRanges = RegularUser(Ranges);
export const MarketPricing = ReadOnlyUser(MarketPricingContainer);
export const CompetitiveSets = RegularUser(CompetitiveSetsContainer);
export const StructureModelingPage = RegularUser(StructureModeling);
export const SurveyLibraryUpdate = SiteAdmin(SurveyLibraryUpdateContainer);
export const DataCutMigrationPage = SiteAdmin(DataCutMigration);
export const DataCutMigrationDetailsPage = SiteAdmin(DataCutMigrationDetails);
export const PayScalePulsePage = ReadOnlyUser(PayScalePulse);
export const GeoDifferentialPage = ReadOnlyUser(GeoDifferential);
export const ViewList = ReadOnlyUser(ViewListContainer);
export const GlobalJobPricingVersioningLanding = SiteAdmin(GlobalJobMatchingVersioningLanding);
export const GlobalJobMatchingVersionsList = SiteAdmin(GloJamVersionsListContainer);
export const EditPricingVersionDetailsPage = SiteAdmin(EditPricingVersionDetails);
export const GlobalJobMatchingPricingVersionStepper = SiteAdmin(GloJamPricingVersionStepperContainer)
export const BulkPricing = RegularUser(BulkPricingContainer);
export const PropagateMatches = RegularUser(PropagateMatchesContainer);
